import { IConversation } from '@color/continuum';

export enum MessageSenderRole {
  USER = 'user',
  BUSINESS = 'business',
}

export interface ZendeskUserJWTResponse {
  token: string;
}

interface IZendeskMessageMetadata {
  is_hidden_from_patient?: boolean;
}

export interface IZendeskMessage {
  id: string;
  // Optional because some messages may not have text content.
  // Though we don't expect this to happen frequently since we only expect text messages from CAs.
  text?: string;
  received: number;
  displayName: string;
  role: MessageSenderRole;
  metadata?: IZendeskMessageMetadata;
}

export interface IConversationWithMessageIds extends IConversation {
  messageIds: Set<string>;
}

export interface IZendeskConversation {
  id: string;
  displayName: string;
  messages: IZendeskMessage[];
}
